import React from "react";
import "./index.css";
import classname from "classname";
import BeatLoader from "react-spinners/BeatLoader";

export const Button = (props) => {
  return (
    <button
      {...props}
      disabled={props.isDisabled ? props.isDisabled : props.loading}
      className={classname(
        props.isDisabled ? "disabled-button" : "button",
        props.isDotted ? "dotted-button" : "button",
        props.small ? "small-button" : "",
        props.color && !props.isDisabled ? props.color : "",
        props.className
      )}
    
      {...props.rest}
    >
      <div className="d-flex align-items-center justify-content-center">
        {props.loading ? (
          <BeatLoader
            color={"#fff"}
            loading={props.loading}
            size={20}
            aria-label=""
            data-testid="loader"
          />
        ) : (
          props.text
        )}
        {props.icon && props.icon}

      </div>
    </button>
  );
};
